import React from 'react'
import PropTypes from 'prop-types'

import { defineMessages } from 'react-intl'

import ChangePasswordForm from '../../../components/ChangePasswordPanel/ChangePasswordForm'

const messages = defineMessages({
  service: '服務管理',
})

export default class ChangePassword extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
    intl: PropTypes.object,
  };

  static propTypes = {
    show:PropTypes.func,
    onHide:PropTypes.func,
    onSubmit:PropTypes.func
  };
  componentDidMount () {
    console.log('change password mount')
  }
  render () {
    const {
      intl: { formatMessage },
    } = this.context

    const {
      show,
      onHide,
      onSubmit,
    } = this.props

    return (
      <ChangePasswordForm
        show={show}
        isLoading={isLoading}
        onHide={onHide}
        errorMessage={errorMessage}
        onSubmit={onSubmit}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/ChangePassword/components/ChangePassword.js